/**
 * Product Index JavaScript - Three Column Grid
 * Handles tab switching, content transitions, and image changes
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    initProductIndex();
  });

  function initProductIndex() {
    initTabSwitching();
  }

  // Tab Switching Functionality
  function initTabSwitching() {
    const tabs = document.querySelectorAll('[data-tab]');
    const contents = document.querySelectorAll('[data-tab-content]');
    const images = document.querySelectorAll('[data-tab-image]');
    
    if (tabs.length === 0) return;
    
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const targetTab = tab.getAttribute('data-tab');
        
        // Remove active class from all tabs
        tabs.forEach(function(t) {
          t.classList.remove('active');
        });
        
        // Remove active class from all content panels
        contents.forEach(function(content) {
          content.classList.remove('active');
        });
        
        // Remove active class from all images
        images.forEach(function(image) {
          image.classList.remove('active');
        });
        
        // Add active class to clicked tab
        tab.classList.add('active');
        
        // Add active class to corresponding content
        const targetContent = document.querySelector('[data-tab-content="' + targetTab + '"]');
        if (targetContent) {
          targetContent.classList.add('active');
        }
        
        // Add active class to corresponding image
        const targetImage = document.querySelector('[data-tab-image="' + targetTab + '"]');
        if (targetImage) {
          targetImage.classList.add('active');
        }
      });
    });
  }

  // Smooth scrolling utility (if needed for future enhancements)
  function smoothScrollTo(element) {
    if ('scrollBehavior' in document.documentElement.style) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      // Fallback for older browsers
      const targetPosition = element.offsetTop - 100;
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = 800;
      let start = null;
      
      function animation(currentTime) {
        if (start === null) start = currentTime;
        const timeElapsed = currentTime - start;
        const run = ease(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animation);
      }
      
      function ease(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
      }
      
      requestAnimationFrame(animation);
    }
  }

  // Touch support for mobile devices
  function initTouchSupport() {
    const productIndex = document.querySelector('.product-index');
    if (!productIndex) return;
    
    let startX = 0;
    let startY = 0;
    
    productIndex.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    });
    
    productIndex.addEventListener('touchend', function(e) {
      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;
      const diffX = startX - endX;
      const diffY = startY - endY;
      
      // Only handle horizontal swipes
      if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > 50) {
        const activeTab = document.querySelector('.product-index__tab.active');
        if (!activeTab) return;
        
        const tabs = Array.from(document.querySelectorAll('.product-index__tab'));
        const currentIndex = tabs.indexOf(activeTab);
        
        let nextIndex;
        if (diffX > 0) {
          // Swipe left - next tab
          nextIndex = currentIndex + 1;
        } else {
          // Swipe right - previous tab
          nextIndex = currentIndex - 1;
        }
        
        if (nextIndex >= 0 && nextIndex < tabs.length) {
          tabs[nextIndex].click();
        }
      }
    });
  }

  // Initialize touch support on mobile
  if ('ontouchstart' in window) {
    initTouchSupport();
  }

})();

